/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Primarystudyinterest_Study_Economics_Education25Inputs */

const en__field__enum_primarystudyinterest_study_economics_education25 = /** @type {(inputs: _Field__Enum_Primarystudyinterest_Study_Economics_Education25Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Economics Education`)
};

const de__field__enum_primarystudyinterest_study_economics_education25 = /** @type {(inputs: _Field__Enum_Primarystudyinterest_Study_Economics_Education25Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wirtschaftspädagogik`)
};

/**
* | output |
* | --- |
* | "Economics Education" |
*
* @param {_Field__Enum_Primarystudyinterest_Study_Economics_Education25Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_primarystudyinterest_study_economics_education25 = /** @type {((inputs?: _Field__Enum_Primarystudyinterest_Study_Economics_Education25Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Primarystudyinterest_Study_Economics_Education25Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_primarystudyinterest_study_economics_education25(inputs)
	return de__field__enum_primarystudyinterest_study_economics_education25(inputs)
});
export { _field__enum_primarystudyinterest_study_economics_education25 as "_field__enum_primaryStudyInterest_STUDY_ECONOMICS_EDUCATION" }